import { NgxLoggerLevel } from 'ngx-logger';

export enum APP_MODE {
	DEVELOP = 'Develop',
	LOCAL = 'Local',
	PRODUCTION = 'Production'
}

export enum LIMIT_TYPES {
	CREATE_ENTITY = 'createEntity',
	IMPORT_ENTITY = 'importEntity'
}

export const APP_MODE_SETTINGS = {
	Develop: {
		loggingConfigOptions: {
			level: NgxLoggerLevel.LOG,
			serverLogLevel: NgxLoggerLevel.ERROR,
			serverLoggingUrl: null,
			disableConsoleLogging: false,
			httpResponseType: 'json',
			enableSourceMaps: true
		},
		limits: {
			createEntity: null
		},
		navbar: {
			fullscreen: {
				order: 1,
				title: 'fullscreen',
				icon: 'ft-maximize',
				isActive: true,
				isVisible: true
			},
			language: {
				order: 2,
				title: 'language',
				icon: 'ft-flag',
				isActive: true,
				isVisible: true
			},
			tour: {
				order: 3,
				title: 'tour',
				icon: 'ft-help-circle',
				isActive: true,
				isVisible: true
			},
			profile: {
				order: 4,
				title: 'profile',
				icon: 'ft-user',
				isActive: true,
				isVisible: true
			}
		},
		sidebar: {
			dashboard: {
				isActive: true,
				isVisible: true
			},
			admin: {
				isActive: true,
				isVisible: true
			},
			tenants: {
				isActive: true,
				isVisible: true
			},
			users: {
				isActive: true,
				isVisible: true
			},
			taxations: {
				isActive: true,
				isVisible: true
			},
			organizations: {
				isActive: true,
				isVisible: true
			},
			businesspremises: {
				isActive: true,
				isVisible: true
			},
			ers: {
				isActive: true,
				isVisible: true
			},
			import: {
				isActive: true,
				isVisible: true
			},
			structureExport: {
				isActive: true,
				isVisible: true
			},
			configuration: {
				isActive: true,
				isVisible: true
			},
			contracts: {
				isActive: true,
				isVisible: true
			},
			clients: {
				isActive: true,
				isVisible: true
			},
			adminConsole: {
				isActive: true,
				isVisible: true
			},
			tss: {
				isActive: true,
				isVisible: true
			},
			myAccount: {
				isActive: true,
				isVisible: true
			},
			test: {
				isActive: true,
				isVisible: true
			}
		}
	},
	Local: {
		loggingConfigOptions: {
			level: NgxLoggerLevel.LOG,
			serverLogLevel: NgxLoggerLevel.ERROR,
			serverLoggingUrl: null,
			disableConsoleLogging: false,
			httpResponseType: 'json',
			enableSourceMaps: true
		},
		limits: {
			createEntity: null
		},
		navbar: {
			fullscreen: {
				order: 1,
				title: 'fullscreen',
				icon: 'ft-maximize',
				isActive: true,
				isVisible: true
			},
			language: {
				order: 2,
				title: 'language',
				icon: 'ft-flag',
				isActive: true,
				isVisible: true
			},
			tour: {
				order: 3,
				title: 'tour',
				icon: 'ft-help-circle',
				isActive: true,
				isVisible: true
			},
			profile: {
				order: 4,
				title: 'profile',
				icon: 'ft-user',
				isActive: true,
				isVisible: true
			}
		},
		sidebar: {
			dashboard: {
				isActive: true,
				isVisible: true
			},
			admin: {
				isActive: true,
				isVisible: true
			},
			tenants: {
				isActive: true,
				isVisible: true
			},
			users: {
				isActive: true,
				isVisible: true
			},
			taxations: {
				isActive: true,
				isVisible: true
			},
			organizations: {
				isActive: true,
				isVisible: true
			},
			businesspremises: {
				isActive: true,
				isVisible: true
			},
			ers: {
				isActive: true,
				isVisible: true
			},
			import: {
				isActive: true,
				isVisible: true
			},
			structureExport: {
				isActive: true,
				isVisible: true
			},
			configuration: {
				isActive: true,
				isVisible: true
			},
			contracts: {
				isActive: true,
				isVisible: true
			},
			clients: {
				isActive: true,
				isVisible: true
			},
			adminConsole: {
				isActive: true,
				isVisible: true
			},
			tss: {
				isActive: true,
				isVisible: true
			},
			myAccount: {
				isActive: true,
				isVisible: true
			},
			test: {
				isActive: true,
				isVisible: true
			}
		}
	},
	Production: {
		loggingConfigOptions: {
			level: NgxLoggerLevel.OFF,
			serverLogLevel: NgxLoggerLevel.OFF,
			serverLoggingUrl: null,
			disableConsoleLogging: true,
			httpResponseType: 'json',
			enableSourceMaps: false
		},
		limits: {
			createEntity: null
		},
		navbar: {
			fullscreen: {
				order: 1,
				title: 'fullscreen',
				icon: 'ft-maximize',
				isActive: false,
				isVisible: false
			},
			language: {
				order: 2,
				title: 'language',
				icon: 'ft-flag',
				isActive: true,
				isVisible: true
			},
			tour: {
				order: 3,
				title: 'tour',
				icon: 'ft-help-circle',
				isActive: false,
				isVisible: false
			},
			profile: {
				order: 4,
				title: 'profile',
				icon: 'ft-user',
				isActive: true,
				isVisible: true
			}
		},
		sidebar: {
			dashboard: {
				isActive: true,
				isVisible: true
			},
			admin: {
				isActive: true,
				isVisible: true
			},
			tenants: {
				isActive: false,
				isVisible: false
			},
			users: {
				isActive: true,
				isVisible: true
			},
			taxations: {
				isActive: true,
				isVisible: true
			},
			organizations: {
				isActive: true,
				isVisible: true
			},
			businesspremises: {
				isActive: true,
				isVisible: true
			},
			ers: {
				isActive: true,
				isVisible: true
			},
			import: {
				isActive: true,
				isVisible: true
			},
			structureExport: {
				isActive: true,
				isVisible: true
			},
			configuration: {
				isActive: true,
				isVisible: true
			},
			contracts: {
				isActive: true,
				isVisible: true
			},
			clients: {
				isActive: true,
				isVisible: true
			},
			adminConsole: {
				isActive: true,
				isVisible: true
			},
			tss: {
				isActive: true,
				isVisible: true
			},
			myAccount: {
				isActive: true,
				isVisible: true
			},
			test: {
				isActive: false,
				isVisible: false
			}
		}
	}
};
